(() => {
  'use strict';

  const initialProductCount = 4;
  const b2bSectionIds = ['tubs', 'b2b-200g-jars', 'b2b-350g-jars'];

  function getProductItems(grid) {
    return [...grid.children].filter((item) => {
      if (item.tagName !== 'LI') return false;
      return !item.classList.contains('cj-wholesale-200g__empty')
        && !item.classList.contains('cj-wholesale-350g__empty');
    });
  }

  function createControl(root, grid, sectionId) {
    let control = root.querySelector('.collection__view-all');
    if (!control) {
      control = document.createElement('div');
      control.className = 'center collection__view-all';

      const insertionPoint = grid.closest('slider-component') || grid;
      insertionPoint.insertAdjacentElement('afterend', control);
    }

    control.classList.add('cj-home-products__control');
    control.replaceChildren();

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button cj-home-products__toggle';
    button.setAttribute('aria-controls', grid.id || `cj-home-product-grid-${sectionId}`);
    button.setAttribute('aria-expanded', 'false');
    button.textContent = 'View all';
    control.append(button);

    return button;
  }

  function setupSection(sectionId) {
    const root = document.getElementById(sectionId);
    if (!root || root.dataset.cjProductDisclosure === 'ready') return;

    const grid = root.querySelector('.product-grid, .cj-wholesale-200g__grid, .cj-wholesale-350g__grid');
    if (!grid) return;

    const items = getProductItems(grid);
    if (items.length <= initialProductCount) {
      root.dataset.cjProductDisclosure = 'ready';
      return;
    }

    if (!grid.id) grid.id = `cj-home-product-grid-${sectionId}`;
    const button = createControl(root, grid, sectionId);

    function render(expanded) {
      items.slice(initialProductCount).forEach((item) => {
        item.hidden = !expanded;
      });
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? 'View less' : 'View all';
      root.classList.toggle('cj-home-products--expanded', expanded);
    }

    button.addEventListener('click', () => {
      render(button.getAttribute('aria-expanded') !== 'true');
    });

    root.dataset.cjProductDisclosure = 'ready';
    render(false);
  }

  function setupAllSections() {
    const hasB2bCatalogue = document.getElementById('b2b-200g-jars') || document.getElementById('b2b-350g-jars');
    if (!hasB2bCatalogue) return;

    b2bSectionIds.forEach(setupSection);
  }

  setupAllSections();
  document.addEventListener('shopify:section:load', setupAllSections);
})();
